import React from "react";
import LeagueTableRow from "./LeagueTableRow";

const LeagueTableW = ({
  table,
  teams = [],
  type = "table",
  name,
  matchId,
  disable = false,
  dictionary,
  sport = "rugby",
  websiteBaseUrl,
  dataPath, dataClient
}) => {
  return (
    <div
      className={`global_table standing_table ${disable ? "d-none" : ""}`}
      data-name={name}
    >
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>{dictionary?.Standings || "Standings"}</th>
            <th>P</th>
            <th>W</th>
            <th>D</th>
            <th>L</th>
            <th>F</th>
            <th>A</th>
            <th>GD</th>
            <th>PTS</th>
          </tr>
        </thead>
        <tbody>
          {table?.map((t, i) => (
            <LeagueTableRow
              data={t}
              key={t?.team?.id}
              teams={teams}
              index={i}
              sport={sport}
              websiteBaseUrl={websiteBaseUrl}
              dataClient={dataClient}
              dataPath={dataPath}
            />
          ))}
        </tbody>
      </table>
      {type === "info" ? (
        <center
          className="link_black underline_text"
          style={{ marginBottom: "10px" }}
        >
          {dictionary?.Seeallstanding || "See all standing"}
        </center>
      ) : (
        ""
      )}
    </div>
  );
};

export default LeagueTableW;
